import React from 'react';
import {
     BsFileEarmarkPost,
     BsFillChatDotsFill,
     BsFillCalendarEventFill,
     BsEmojiHeartEyesFill,
     BsQuestionDiamondFill,
   } from "react-icons/bs";
   
import { SiFandango } from "react-icons/si";

import { AiFillAudio } from "react-icons/ai"
import { FaChalkboardTeacher } from "react-icons/fa";
import StarCardSchedule from '../Reuse/StarCardSchedule';

const StarSchedule = () => {
  return (
    <>
      <div className="row">

          <StarCardSchedule link={"/superstar/schedule/single"}  title={"Simple-Post"} icon={<BsFileEarmarkPost size={50} />} />
          {/* <StarCardSchedule link={"/superstar/schedule/single"} title={"Audition"} icon={<AiFillAudio size={50} />} /> */}
          <StarCardSchedule link={"/superstar/schedule/single"} title={"Live-Chat"} icon={<BsFillChatDotsFill size={50} />} />
          <StarCardSchedule link={"/superstar/schedule/single"} title={"Meetup-Event"} icon={<BsFillCalendarEventFill size={50} />} />
          <StarCardSchedule link={"/superstar/schedule/single"} title={"Learning-Session"} icon={<BsEmojiHeartEyesFill size={50} />} />
          <StarCardSchedule link={"/superstar/schedule/single"} title={"Greeting"} icon={<FaChalkboardTeacher size={50} />} />
          <StarCardSchedule link={"/superstar/star-showcase"} title={"Star-Showcase"} icon={<FaChalkboardTeacher size={50} />} />
          <StarCardSchedule link={"/superstar/schedule/single"} title={"Fan-Group"} icon={<SiFandango size={50} />} />
          <StarCardSchedule link={"/superstar/schedule/single"} title={"Q&A"} icon={<BsQuestionDiamondFill size={50} />} />

      </div>
    </>
  )
}

export default StarSchedule
